import {
    INVOICE_TYPE_LIST_REQUEST,
    INVOICE_TYPE_LIST_SUCCESS,
    INVOICE_TYPE_LIST_FAIL,
    INVOICE_TYPE_LIST_RESET,
    INVOICE_TYPE_CREATE_REQUEST,
    INVOICE_TYPE_CREATE_SUCCESS,
    INVOICE_TYPE_CREATE_FAIL,
    INVOICE_TYPE_GET_REQUEST,
    INVOICE_TYPE_GET_SUCCESS,
    INVOICE_TYPE_GET_FAIL,
    INVOICE_TYPE_UPDATE_SUCCESS,
    INVOICE_TYPE_UPDATE_REQUEST,
    INVOICE_TYPE_UPDATE_FAIL,
    INVOICE_TYPE_DELETE_REQUEST,
    INVOICE_TYPE_DELETE_SUCCESS,
    INVOICE_TYPE_DELETE_FAIL
} from '../constants/invoiceTypeConstants'

export const invoiceTypeListReducer = (state = { invoicetypes: [] }, action) => {
    switch (action.type) {
        case INVOICE_TYPE_LIST_REQUEST:
            return { loading: true };
        case INVOICE_TYPE_LIST_SUCCESS:
            return { loading: false, invoicetypes: action.payload }
        case INVOICE_TYPE_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const invoiceTypeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case INVOICE_TYPE_CREATE_REQUEST:
            return { loading: true };
        case INVOICE_TYPE_CREATE_SUCCESS:
            return { loading: false, success: action.payload }
        case INVOICE_TYPE_CREATE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const invoiceTypeDetailsReducer = (state = { invoicetype: [] }, action) => {
    switch (action.type) {
        case INVOICE_TYPE_GET_REQUEST:
            return { loading: true, invoicetype: [] };
        case INVOICE_TYPE_GET_SUCCESS:
            return { loading: false, invoicetype: action.payload }
        case INVOICE_TYPE_GET_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const invoiceTypeUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case INVOICE_TYPE_UPDATE_REQUEST:
            return { loading: true };
        case INVOICE_TYPE_UPDATE_SUCCESS:
            return { loading: false, success: action.payload }
        case INVOICE_TYPE_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

export const invoiceTypeDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case INVOICE_TYPE_DELETE_REQUEST:
            return { loading: true };
        case INVOICE_TYPE_DELETE_SUCCESS:
            return { loading: false, success: action.payload }
        case INVOICE_TYPE_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}

